const STORAGE_KEY = 'ggc_recent_campaign_ids';
const MAX_RECENT = 10;

export function getRecentCampaignIds(): string[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]');
  } catch {
    return [];
  }
}

export function addRecentCampaignId(id: string): string[] {
  if (id === 'all') return getRecentCampaignIds();
  const prev = getRecentCampaignIds();
  const next = [id, ...prev.filter((x) => x !== id)].slice(0, MAX_RECENT);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}

export function removeRecentCampaignId(id: string): string[] {
  const prev = getRecentCampaignIds();
  const next = prev.filter((x) => x !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}
